import { ATTENDEESMESSAGING_TOTAL_SENTMSG } from "AttendeesmessagingSentmsgAction";
import { ATTENDEESMESSAGING_TOTAL_COMMUNICATION } from "AttendeesmessagingCommunicationAction";
import { ATTENDEESMESSAGING_TOTAL_RECEMSG } from "AttendeesmessagingRecemsgAction";
import { ATTENDEESMESSAGING_TOTAL_MSGTHREAD } from "AttendeesmessagingMsgthreadAction";

export var ATTENDEESMESSAGING_SENTMSG = "ATTENDEESMESSAGING_SENTMSG";
export var ATTENDEESMESSAGING_COMMUNICATION =
  "ATTENDEESMESSAGING_COMMUNICATION";
export var ATTENDEESMESSAGING_RECEMSG = "ATTENDEESMESSAGING_RECEMSG";
export var ATTENDEESMESSAGING_MSGTHREAD = "ATTENDEESMESSAGING_MSGTHREAD";

export var ATTENDEESMESSAGING_SELECTED_ITEM =
  "ATTENDEESMESSAGING_SELECTED_ITEM";
export var ATTENDEESMESSAGING_ITEM_SELECTED =
  "ATTENDEESMESSAGING_ITEM_SELECTED"; // main

export function onAttendeesmessagingMenuSelected(selectedMenu) {
  return (dispatch) => {
    dispatch({ type: ATTENDEESMESSAGING_ITEM_SELECTED, payload: selectedMenu });
  };
}

export function dispatchAnalyticsData(data) {
  return (dispatch) => {
    //dispatch({type: SOCIALFEED_TOTAL_POST, payload: {count:data}}); count:data.devices.count
    dispatch({
      type: ATTENDEESMESSAGING_TOTAL_SENTMSG,
      payload: { count: data },
    });
    dispatch({
      type: ATTENDEESMESSAGING_TOTAL_COMMUNICATION,
      payload: { count: data },
    });
    dispatch({
      type: ATTENDEESMESSAGING_TOTAL_RECEMSG,
      payload: { count: data },
    });
    dispatch({
      type: ATTENDEESMESSAGING_TOTAL_MSGTHREAD,
      payload: { count: data },
    });
  };
}
